import { Link } from 'react-router-dom';
import { trackCrawlCardClick } from '@/utils/analytics';
import { resolveMediaUrl, isVideoUrl } from '@/utils/media';

const CITY_COLORS = {
  'Miami': '#FF6B6B',
  'Austin': '#FFB347',
  'New York': '#1E90FF',
  'Nashville': '#22C55E',
  'Chicago': '#A855F7',
  'Denver': '#A855F7',
  'San Diego': '#00F5FF',
};

const CrawlCard = ({ crawl }) => {
  const cityColor = CITY_COLORS[crawl.city] || '#FF2D78';

  return (
    <Link
      to={`/crawls/${crawl.id}`}
      data-testid={`crawl-card-${crawl.id}`}
      className="group block rounded-[16px] overflow-hidden transition-all duration-200 ease-out hover:-translate-y-1"
      style={{
        background: '#FFFFFF',
        border: `1px solid ${cityColor}30`,
        boxShadow: `0 8px 30px rgba(0,0,0,0.08)`,
      }}
      onMouseEnter={(e) => e.currentTarget.style.boxShadow = `0 12px 40px rgba(0,0,0,0.12), 0 0 20px ${cityColor}25`}
      onMouseLeave={(e) => e.currentTarget.style.boxShadow = `0 8px 30px rgba(0,0,0,0.08)`}
      onClick={() => trackCrawlCardClick(crawl.id, crawl.city)}
    >
      {/* City accent bar */}
      <div className="h-[6px] w-full" style={{ backgroundColor: cityColor }} />

      {/* Image */}
      <div className="relative h-72 overflow-hidden">
        {isVideoUrl(crawl.image_url) ? (
          <video
            src={resolveMediaUrl(crawl.image_url)}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            muted autoPlay loop playsInline
          />
        ) : (
          <img
            src={resolveMediaUrl(crawl.image_url)}
            alt={crawl.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        )}
        <div className="absolute inset-0 card-image-fade" style={{ background: 'linear-gradient(to top, #080010 0%, rgba(8,0,16,0.6) 30%, transparent 55%)' }} />

        <div className="absolute top-3 right-3 bg-hot-pink text-white font-display text-sm px-3 py-1 rounded-full" data-testid="card-price-badge">
          FROM ${crawl.price_general}
        </div>

        <div className="absolute bottom-3 left-4">
          <h3 className="font-display text-[36px] text-white leading-none uppercase tracking-wide drop-shadow-lg">
            {crawl.city}
          </h3>
        </div>
      </div>

      {/* Content */}
      <div className="p-5 card-info-area">
        <p className="font-subheading text-[13px] uppercase tracking-[2px]" style={{ color: cityColor }}>
          {crawl.neighborhood}
        </p>
        <h4 className="font-display text-xl text-[#080010] uppercase mt-1">
          {crawl.title}
        </h4>

        <div className="flex items-center gap-4 mt-4">
          <span className="font-mono text-[11px] text-[#080010]/40 uppercase">{crawl.date}</span>
          <span className="font-mono text-[11px] text-[#080010]/40">|</span>
          <span className="font-mono text-[11px] text-[#080010]/40 uppercase">{crawl.time}</span>
          <span className="font-mono text-[11px] text-[#080010]/40">|</span>
          <span className="font-mono text-[11px] text-[#080010]/40">{crawl.bars_count} BARS</span>
        </div>

        {/* Spots remaining bar */}
        <div className="mt-4">
          <div className="h-1.5 bg-[#080010]/10 spots-bar-track rounded-full overflow-hidden">
            <div className="h-full bg-hot-pink rounded-full transition-all" style={{ width: `${((crawl.spots_total - crawl.spots_remaining) / crawl.spots_total) * 100}%` }} />
          </div>
          <p className="font-mono text-[10px] text-[#080010]/30 mt-1">{crawl.spots_remaining} SPOTS LEFT</p>
        </div>

        {/* GET TICKETS CTA — flat stamp */}
        <div
          className="mt-5 font-display text-[15px] tracking-[1px] text-center py-3 uppercase transition-all duration-150 group-hover:opacity-90"
          style={{ backgroundColor: '#FF2D78', color: '#FFFFFF' }}
          data-testid="card-get-tickets-btn"
        >
          Get Tickets
        </div>
      </div>
    </Link>
  );
};

export default CrawlCard;
